import { useTransition } from 'react';
import { useNavigate } from 'react-router-dom';
const useTransitionNavigate = () => {
    const [, startTransition] = useTransition();
    const navigate = useNavigate();
    return (to, options) => startTransition(() => navigate(to, options));
};
export default useTransitionNavigate;
